module.exports = __webpack_public_path__ + "img/ico-ders-notlari.8231fd0b.svg";